import { render } from "./CategoryImageEditor.vue?vue&type=template&id=b0e7f946&ts=true"
import script from "./CategoryImageEditor.vue?vue&type=script&lang=ts"
export * from "./CategoryImageEditor.vue?vue&type=script&lang=ts"

import "./CategoryImageEditor.vue?vue&type=style&index=0&id=b0e7f946&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__